export interface BlogPost {
  id: string
  title: string
  excerpt: string
  category: string
  date: string
  imageUrl: string
  content?: string
}
export const blogPosts: BlogPost[] = [
    {
    id: 'postpartum-nutrition',
    title: '🌸 Postpartum Nutrition: Caring for Yourself',
    excerpt:
      'Why what you eat matters for recovery and breastfeeding. Bringing your baby into the world is one of the most powerful things your body will ever do.',
    category: 'Maternal Health',
    date: 'June 15, 2023',
    imageUrl:
      'https://images.unsplash.com/photo-1490818387583-1baba5e638af?ixlib=rb-1.2.1&auto=format&fit=crop&w=1350&q=80',
    content: `Bringing your baby into the world is one of the most powerful things your body will ever do. But after childbirth, your body also needs time, rest, and nourishment to heal. Many new moms focus entirely on their little one and forget the importance of caring for themselves. The truth is, your nutrition matters just as much now as it did during pregnancy — both for your recovery and for your baby's growth (if you're breastfeeding).
🥗 Why Postpartum Nutrition Is So Important
Healing & Recovery Childbirth — whether vaginal or cesarean — puts your body under immense stress. Nutrients like protein, vitamin C, and zinc help repair tissues and speed up healing.
Energy for Motherhood Newborn life can be exhausting. Eating balanced meals keeps your energy stable so you can keep up with feedings, diaper changes, and endless cuddles.
Breastfeeding Support Your breast milk quality is generally consistent, but your diet can affect its nutrient profile. Staying nourished helps your body keep up with the demand of milk production.
Emotional Well-being Good nutrition supports mental health too — helping reduce the risk of postpartum depression and mood swings.
🍲 Essential Nutrients for New Moms
Protein (beans, eggs, fish, lean meat) → repairs tissues and keeps you full.
Iron (beef, spinach, ugu, beans) → replenishes blood lost during delivery.
Calcium (milk, yoghurt, soy, okra) → supports bone health for you and baby.
Healthy Fats (avocado, groundnuts, palm oil, fish) → support baby's brain development.
Fruits & Vegetables (pawpaw, oranges, carrots, green leafy veggies) → vitamins for healing, immunity, and digestion.
Fluids (water, zobo without sugar, pap, smoothies) → prevent dehydration, especially for breastfeeding moms.
🥘 Nigerian-Friendly Meal Ideas
Breakfast: Oats with banana and groundnuts, or pap with milk and moi-moi.
Lunch: Rice with beans and fish stew, or yam pottage with vegetables.
Dinner: Efo riro with semovita, or plantain porridge with crayfish.
Snacks: Roasted groundnuts, fruit salad, boiled corn, smoothies.
💡 Practical Tips for Moms
Don't skip meals — snack smartly if you're too tired to cook.
Batch cook and freeze stews or soups for easy reheating.
Keep water bottles within reach during breastfeeding sessions.
Accept help when offered — let loved ones cook or shop for you.
🌱 Final Word
Mama, caring for yourself is part of caring for your baby. Every nutrient you eat fuels your healing, restores your strength, and gives you the energy to enjoy motherhood. Don't see postpartum nutrition as a luxury — see it as your foundation for thriving in this new season.`},
    {
    id: 'allergenic-foods',
    title: '🌸 Introducing Allergenic Foods to Your Baby',
    excerpt:
      'A guide to safely introducing common allergenic foods and what signs to watch for. Starting solids is such an exciting milestone.',
    category: 'Health & Safety',
    date: 'July 2, 2023',
    imageUrl:
      'https://images.unsplash.com/photo-1596463059283-da257325bab8?ixlib=rb-1.2.1&auto=format&fit=crop&w=1350&q=80',
    content: `Starting solids is such an exciting milestone, but when it comes to foods that may cause allergies, many moms feel nervous — and that's completely normal. The good news is, with the right approach, introducing allergenic foods can actually help reduce the risk of allergies later in life.
🥜 What Are Allergenic Foods?
These are foods more likely to trigger allergies in babies. Common ones include:
Eggs 🥚
Peanuts (groundnuts) & other nuts 🥜
Cow's milk 🥛
Wheat 🌾
Soy 🌱
Fish & shellfish 🐟
🍼 When Should You Start?
Around 6 months, once your baby is ready for solids.
Make sure your baby is healthy (not sick) when trying a new allergenic food.
Introduce them one at a time, with a few days in between.
👩‍🍳 How to Introduce Safely
Start small — mix a little into a food your baby already enjoys.
Watch closely for 2 hours after the first few bites.
Avoid whole nuts (choking hazard). Use smooth pastes or powders instead.
Cook eggs thoroughly (scrambled or boiled) before offering.
🚨 Watch Out For These Signs of Allergy
Reactions often happen quickly. Call your doctor right away if you notice:
Rash, hives, or swelling
Vomiting or diarrhea
Wheezing, coughing, or difficulty breathing (this is an emergency!)
💡 Extra Tips for Moms
Don't delay allergenic foods longer than necessary — early introduction is often safer.
If your family has a history of severe allergies, check with your pediatrician before starting.
Keep calm. Most babies tolerate allergenic foods just fine.
🌱 Final Word
Introducing allergenic foods doesn't have to be scary. Go slow, stay observant, and trust your instincts. With care, your baby can enjoy a wider variety of nutritious foods and you can enjoy peace of mind.`},
    {
    id: 'nutrition-myths',
    title: '🍼 Common Baby Nutrition Myths Debunked',
    excerpt:
      'Separating fact from fiction about feeding your little one. As moms, we hear all sorts of advice about feeding our babies.',
    category: 'Education',
    date: 'July 18, 2023',
    imageUrl:
      'https://images.unsplash.com/photo-1590005354167-6da97870c757?ixlib=rb-1.2.1&auto=format&fit=crop&w=1350&q=80',
    content: `As moms, we hear all sorts of advice about feeding our babies — from aunties, neighbors, friends, and even strangers! While some advice can be helpful, a lot of it is based on myths that can leave you confused or even stressed about your baby's nutrition.
Let's set the record straight by tackling some of the most common baby nutrition myths and giving you the facts you need for peace of mind. 💕
🌱 Myth 1: "A chubby baby is always a healthy baby."
The truth: Weight isn'It is not the only sign of health. A baby can be small and still perfectly healthy as long as they are active, meeting milestones, and eating a balanced diet. What matters most is steady growth on your baby's growth chart, not being "chubby."
🌱 Myth 2: "Babies need solid food as early as 3–4 months."
The truth: Experts recommend starting solids at 6 months. Before then, breast milk (or formula) provides all the nutrition your baby needs. Starting solids too early can put unnecessary stress on a baby's digestive system.
🌱 Myth 3: "Pap is enough for weaning."
The truth: While pap (ogi/akamu) is common in Nigeria, on its own it doesn't provide all the nutrients your baby needs. Babies also need proteins (like eggs, beans, fish), healthy fats (like avocado, groundnut paste), and vitamins from fruits and vegetables. Pap can be enriched, but variety is key.
🌱 Myth 4: "Babies need water immediately after birth."
The truth: For the first 6 months, breast milk (or formula) is all the water and nutrition your baby needs. Giving water too early can fill their tiny tummy and reduce how much milk they take, which can affect growth.
🌱 Myth 5: "Sweeteners like honey are safe for babies."
The truth: Honey should not be given to babies under 1 year because it can cause infant botulism — a serious illness. Instead, use natural fruits like banana, pawpaw, or mango to sweeten purees and porridges.
🌱 Myth 6: "If a baby refuses a food once, they'll never eat it."
The truth: It's normal for babies to reject a new food the first few times. Don't give up! It can take 10–15 tries before a baby accepts a new taste or texture.
🌸 Final Word for Moms
Every baby is different, and no one knows your little one better than you. Trust your instincts, rely on trusted health sources, and don't let myths cause unnecessary worry. What your baby needs most is love, patience, and balanced nutrition at the right time. 💕`},
    {
            id: 'picky-eaters',
            title: '🥄 Dealing with Picky Eaters: Expert Strategies',
            excerpt: '',
            category: 'Challenges',
            date: 'August 5, 2023',
            imageUrl: '',
            content: '`If your baby or toddler refuses certain foods spits out veggies or insists on eating the same thing every day you\'re not alone. Picky eating is a very common stage in childhood development. While it can feel frustrating the good news is that with a little patience and strategy you can gently guide your child toward a healthier more balanced diet. 💕'
        },
    {
    id: 'meal-prep',
    title: '⏰ Time-Saving Baby Food Meal Prep Tips',
    excerpt:
      'Learn how to prepare nutritious baby food in advance to save time during busy weekdays.',
    category: 'Tips & Tricks',
    date: 'August 22, 2023',
    imageUrl:
      'https://images.unsplash.com/photo-1547592180-85f173990554?ixlib=rb-1.2.1&auto=format&fit=crop&w=1350&q=80',
    content: `If you'As a mom, you already know – mealtimes with a baby can feel like a full-time job. Between nursing, cleaning, diaper changes, and trying to catch your breath, preparing fresh meals every day may seem overwhelming. The good news? With a little planning, you can save time, reduce stress, and still give your baby nutritious, homemade meals. Let's talk about some practical baby food meal prep tips designed especially for you. 💕
🥕 1. Plan Ahead with a Weekly Menu
Think about what foods your baby will eat in the coming week. For example, Monday could be pureed sweet potato, Tuesday mashed avocado, Wednesday pap enriched with milk. Having a plan keeps you from scrambling daily and ensures your baby enjoys variety.
🍲 2. Cook in Batches
Instead of cooking small portions every day, prepare bigger batches of baby food. For instance, steam carrots, pumpkin, or beans once, then blend and store. You'll save time and energy while still offering wholesome meals.
❄️ 3. Store Smartly
Use small containers or ice cube trays to portion out purees, soups, or porridges. Once frozen, transfer cubes into labeled ziplock bags. This way, you can defrost exactly what you need without waste.
🥄 4. Mix & Match for Variety
Meal prep doesn't mean boring meals. Combine prepped foods in new ways:
Potato puree + soya beans = creamy, protein-rich blend.
Pap + mashed banana = quick, sweet, energy-boosting meal.
Sweet potato + Titus fish = nutrient-packed lunch.
This keeps meals exciting for your little one while keeping things simple for you.
🍌 5. Keep Healthy Snacks Handy
Cut soft fruits like ripe pawpaw, banana, or avocado in advance (store in the fridge for the day). Having these ready makes it easy to grab-and-feed when your baby needs a quick bite.
🌸 Bonus Tip: Stay Flexible
Some days will be smooth, others may feel messy. That's okay, mama. The goal isn't perfection — it's creating a system that makes feeding easier for both you and your baby.
💕 Final Thoughts
Meal prep is more than a time-saver; it's a way to gift yourself peace of mind while ensuring your baby eats healthy, balanced meals. With these tips, you can spend less time stressing in the kitchen and more time enjoying precious moments with your little one. Because a nourished baby and a less-stressed mom is the best recipe of all. 🌸`},
    {
            id: 'first-foods',
            title: '🌸 The Best First Foods for Your Baby',
            excerpt: '',
            category: 'Nutrition',
            date: 'September 10, 2023',
            imageUrl: '',
            content: '`One of the most exciting milestones in your baby\'s first year is starting solid foods. For many moms it\'s a mix of joy nerves and endless questions: "What should I give first?" "Will my baby like it?" "Am I doing it right?" Don\'t worry — you\'re not alone. Let\'s walk through this together.'
        }
]